var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpades = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1038 50L22.964 40.2502L18.8241 50C21.523 49.1801 24.4049 49.1801 27.1038 50Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70621 20.3875C3.53136 21.5608 2.59937 22.9538 1.96346 24.4868C1.32755 26.0199 1.00017 27.6631 1 29.3225C0.999834 30.982 1.32689 32.6252 1.9625 34.1584C2.5981 35.6916 3.52981 37.0847 4.70442 38.2583C5.87903 39.4318 7.27355 40.3627 8.80834 40.9979C10.3431 41.6331 11.9882 41.9601 13.6495 41.9603C15.3108 41.9605 16.9559 41.6338 18.4908 40.9989C20.0257 40.364 21.4204 39.4333 22.5953 38.26C22.6479 38.2071 22.7111 38.1658 22.7806 38.1386C22.8502 38.1114 22.9247 38.0991 22.9993 38.1023L23.1203 38.1071C23.2533 38.1124 23.3796 38.1666 23.4751 38.2592C25.8659 40.6103 29.0937 41.9165 32.4486 41.8904C35.8035 41.8642 39.0106 40.508 41.3643 38.1199C43.7181 35.7319 45.0258 32.5076 44.9996 29.1565C44.9735 25.8054 43.6157 22.6019 41.2249 20.2508L22.9516 2L4.70621 20.3875Z",
    stroke: "white",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpades);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spades.3e8b4cdc.svg";